import React from "react";
import { CardHeader, CardContent, Card, Icon } from "semantic-ui-react";
import { Template } from "./Template";
import "./TemplateBar.scss";
import { TemplatesManager } from "./TemplatesManager";

export function TemplateBar(props: any) {
  const { onDragTemplate } = props;

  return (
    <div className="template-bar">
      <Card className="template-bar__card" fluid>
        <CardContent className="content-header">
          <CardHeader>
            <Icon name="folder open outline" />
            Plantillas
          </CardHeader>
        </CardContent>
        <CardContent className="content-list">
          <h3 className="template-group">Clases</h3>
          <div className="template-list">
            {TemplatesManager.multimediaTemplates.map((template, index) => (
              <Template
                key={index}
                template={template}
                onDragStart={(e) => onDragTemplate(e, template.component)}
              />
            ))}
          </div>
          <h3 className="template-group">Cuestionario</h3>
          <div className="template-list">
            {TemplatesManager.questionTemplates.map((template, index) => (
              <Template
                key={index}
                template={template}
                onDragStart={(e) => onDragTemplate(e, template.component)}
              />
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
